// enquiry page
// @author Shahin
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import "../style.css";
import { error } from "jquery";
import Login from "../Login/login";
import { ReactComponent as LoadingIcon } from "../../../src/cpanel-loading.svg";
import { toast } from "react-toastify";
import Register from "../register/Register";
import { API_URL } from "../../config";

export default function Enquiry({ isEnquiry, handleIsEnquiry}) {
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    phone: "",
    companyName: "",
    email: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const companyNameRegex =
      /^(?=(?:[^a-zA-Z0-9]*[a-zA-Z0-9]){3})[a-zA-Z0-9\s!@#$%^&*(),.?":{}|<>]{3,}$/;

    let { name, value } = e.target;
    if (name === "phone") {
      value = value.toString().replace(/[^0-9]/g, ""); // Allow only numbers
      if (value.length > 10) {
        value = value.slice(0, 10); // Truncate to 10 digits
      }
    }

    if (name === "firstName" && value.toString().length > 25) {
      value = value.toString().slice(0, 25); // Truncate to 26 characters
    }
    if (name === "lastName" && value.toString().length > 25) {
      value = value.toString().slice(0, 25); // Truncate to 26 characters
    }
    if (name === "middleName" && value.toString().length > 25) {
      value = value.toString().slice(0, 25); // Truncate to 26 characters
    }

    if (name === "companyName" && value.toString().length > 50) {
      value = value.toString().slice(0, 50); // Truncate to 51 characters
    }

    const updatedValues = { ...formData, [name]: value };
    setFormData(updatedValues);

    switch (name) {
      case "firstName":
        errors.firstName =
          value.trim() === ""
            ? "First name is required"
            : !/^[A-Za-z]+$/.test(value)
            ? "Name is invalid"
            : "";
        break;
      case "lastName":
        errors.lastName =
          value.trim() === ""
            ? "Last name is required"
            : !/^[A-Za-z]+$/.test(value)
            ? "Last name is invalid"
            : "";
        break;
      case "middleName":
        errors.middleName =
          value.trim() === "" // If the value is empty
            ? "" // No error for empty value
            : !/^[A-Za-z]+$/.test(value) // If the value contains invalid characters (not just letters)
            ? "Middle name is invalid" // Error message for invalid characters
            : "";
        break;
      case "phone":
        errors.phone = value.trim() ? "" : "Mobile is required";
        errors.phone = value.length > 9 ? "" : "Mobile is required";
        break;

      case "companyName":
        errors.companyName = value.trim()
          ? companyNameRegex.test(value.trim())
            ? ""
            : "Please enter valid company name."
          : "Company Name is required";
        break;

      case "email":
        errors.email = !/\S+@\S+\.\S+/.test(value) ? "Invalid email" : "";
        break;
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
        setLoading(true);
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return;
    }
    setErrors({});
    try {
      const data = await axios.post(
        `${API_URL}/auth/enquiry`,
        formData
      );
      toast.success("Enquiry sent successfully.");
      console.log(data);
      setFormData({
        firstName: "",
        middleName: "",
        lastName: "",
        phone: "",
        companyName: "",
        email: "",
      });
      setErrors({});
      setLoading(false);
    } catch (error) {
      toast.error(error.message);
      setLoading(false);
    }
  };

  const validate = () => {
    let errors = {};
    if (!formData.firstName) errors.firstName = "First name is required";
    if (!formData.lastName) errors.lastName = "Last name is required";
    if (!formData.email) errors.email = "Email is required";
    if (!formData.phone) errors.phone = "Phone number is required";
    if (!/^\d{10}$/.test(formData.phone))
      errors.phone = "Phone number is invalid";
    if (!formData.companyName) errors.companyName = "Company name is required";
    if (!/\S+@\S+\.\S+/.test(formData.email)) errors.email = "Email is invalid";
    return errors;
  };
  return (
    <section className="contact-section bg-color-1">
      <div className="auto-container">
        <div className="sec-title centred">
          <div className="title-two">
            <p>
              <span>{"{"}</span>&nbsp;Contact us&nbsp;<span>{"}"}</span>
            </p>
          </div>
          <h3>Ready to rent a machine? We're here to help, anytime!</h3>
        </div>
        <div className="row clearfix">
          <div className="col-lg-6 col-md-12 col-sm-12 image-column">
            <div
              style={{
                paddingTop: "40px",
                height: "auto",
              }}
              className="image-box wow slideInLeft animated"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <div className="icon-box">
                <div
                  className="iocn icon-1"
                  style={{
                    backgroundImage: "url(assets/images/icons/icon-7.png)",
                  }}
                />
                <div
                  className="iocn icon-2 rotate-me"
                  style={{
                    backgroundImage: "url(assets/images/icons/icon-8.png)",
                  }}
                />
              </div>
              <figure className="image js-tilt">
                <img
                  src="assets/sample images/register_page.png"
                  style={{ marginTop: "-50px", width: "100%" }}
                  alt=""
                />
              </figure>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 form-column">
            <div className="contact-form-inner">
              {isEnquiry==='register'? <Register handleIsEnquiry={handleIsEnquiry} isEnquiry={isEnquiry} />: isEnquiry==='enquiry' ? (
                <form
                  onSubmit={handleSubmit}
                  id="contact-form"
                  className="default-form"
                >
                  <div className="row clearfix">
                    <div className="col-lg-4 col-md-4 col-sm-12 form-group">
                      <input
                        id="firstName"
                        type="text"
                        name="firstName"
                        placeholder="First name *"
                        value={formData.firstName}
                        onChange={handleChange}
                        style={
                          errors.firstName ? { border: "1px solid red" } : {}
                        }
                      />
                      {errors.firstName && (
                        <span className="error" style={{ color: "red" }}>
                          {errors.firstName}
                        </span>
                      )}
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12 form-group">
                      <input
                        type="text"
                        name="middleName"
                        placeholder="Middle Name"
                        value={formData.middleName}
                        onChange={handleChange}
                      />
                      {errors.middleName && (
                        <span className="error" style={{ color: "red" }}>
                          {errors.middleName}
                        </span>
                      )}
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12 form-group">
                      <input
                        type="text"
                        name="lastName"
                        placeholder="Last Name *"
                        value={formData.lastName}
                        onChange={handleChange}
                        style={
                          errors.lastName ? { border: "1px solid red" } : {}
                        }
                      />
                      {errors.lastName && (
                        <span className="error" style={{ color: "red" }}>
                          {errors.lastName}
                        </span>
                      )}
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                      <input
                        type="text"
                        name="companyName"
                        placeholder="Company Name *"
                        value={formData.companyName}
                        onChange={handleChange}
                        style={
                          errors.companyName ? { border: "1px solid red" } : {}
                        }
                      />
                      {errors.companyName && (
                        <span className="error" style={{ color: "red" }}>
                          {errors.companyName}
                        </span>
                      )}
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                      <input
                        type="text"
                        name="email"
                        placeholder="Email *"
                        value={formData.email}
                        onChange={handleChange}
                        style={errors.email ? { border: "1px solid red" } : {}}
                      />
                      {errors.email && (
                        <span className="error" style={{ color: "red" }}>
                          {errors.email}
                        </span>
                      )}
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                      <input
                        type="text"
                        name="phone"
                        placeholder="phone *"
                        value={formData.phone}
                        onChange={handleChange}
                        style={errors.phone ? { border: "1px solid red" } : {}}
                      />
                      {errors.phone && (
                        <span className="error" style={{ color: "red" }}>
                          {errors.phone}
                        </span>
                      )}
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12 form-group message-btn">
                      {loading ? (
                        <LoadingIcon
                          style={{
                            height: 50,
                            width: "100%",
                          }}
                        />
                      ) : (
                        <button
                          className="theme-btn style-four"
                          type="submit"
                          name="submit-form"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          Enquire Now
                          
                        </button>
                      )}
                    </div>
                  </div>
                </form>
              ) : (
                <Login handleIsEnquiry={handleIsEnquiry} isEnquiry={isEnquiry}/>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
